export default __webpack_public_path__ + "static/media/CNH_verse.0d1c4c66.png";